import useWaffleFlag from "../../react-query/queries/useWaffleFlag";
import BillingFailedBanner from "./BillingFailedBanner";
import CapacityLimitBanner from "./CapacityLimitBanner";
import TrialAnnouncementBanner from "./TrialAnnouncementBanner";
import ViewingAsBanner from "./ViewingAsBanner";
import OptimismGoerliDeprecationBanner from "./OptGoerliDeprecationBanner";

const Banners = () => {
  const { isEnabled: usageLimitBannerEnabled } =
    useWaffleFlag("usage_limit_banner");

  return (
    <div>
      <ViewingAsBanner />
      <OptimismGoerliDeprecationBanner />
      <BillingFailedBanner />
      {!usageLimitBannerEnabled && <CapacityLimitBanner />}
      <TrialAnnouncementBanner />
    </div>
  );
};

export default Banners;
